import React from 'react';

import { Checkbox } from 'antd';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseTextArea from 'components/BaseForm/BaseTextArea';
import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { CSSUtils } from 'utils/CSSUtils';

import { DashboardConfigurationFilterFormValues } from '../../../types';
import { useFetchMicroServicesName } from '../../../useFetchMicroServicesName';

import { FormFooter } from './FormFooter/FormFooter';

interface ConfigurationAdminFonctionnelFilterFormProps {
  filter: Partial<DashboardConfigurationFilterFormValues>;
  setFilter: (value: Partial<DashboardConfigurationFilterFormValues>) => void;
}

function ConfigurationAdminFonctionnelFilterForm({
  filter,
  setFilter,
}: ConfigurationAdminFonctionnelFilterFormProps) {
  const microServiceOptions = useFetchMicroServicesName();

  return (
    <BaseForm
      initialValues={filter}
      onSubmit={() => Promise.resolve()}
      inputs={[
        {
          name: 'microServiceName',
          label: 'Service',
          render: () => (
            <BaseSelect
              options={microServiceOptions ?? []}
              getOptionValue={option => option.toString()}
              getOptionLabel={option => option.toString()}
              allowClear
            />
          ),
        },
        {
          name: 'value',
          label: 'Valeur',
          render: () => <BaseTextArea />,
        },
        {
          name: 'hasError',
          label: 'Configurations en erreur',
          valuePropName: 'checked',
          render: () => <Checkbox />,
        },
      ]}
      renderButtonAction={() => <FormFooter setFilter={setFilter} />}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}

export default ConfigurationAdminFonctionnelFilterForm;
